<template>
    <div class="table-responsive visitors-table-container" id="table-rounds">
        <app-data-table
            v-if="!!data"
            :fields="fields"
            :items="data"
            :from="data.from"
            :to="data.to"
            :current-page="data.current_page"
            :last-page="data.last_page"
            :total="data.total"
            :per-page="data.per_page"
            :on-change-page="onChangePage"
        >
            <template slot="id" slot-scope="{ item }">{{
                `${item.id}`.padStart(4, '0')
            }}</template>
            <template slot="date" slot-scope="{ item }">
                {{ item.date | date }}
            </template>
            <template slot="accomplishment" slot-scope="{ item }">
                {{ (item.accomplishment / 100) | percentaje(2) }}
            </template>
            <template slot="actions" slot-scope="{ item }">
                <b-btn
                    size="sm"
                    v-if="
                        !(
                            item.ticket_status.slug === 'cerrado' ||
                            item.ticket_status.slug === 'finalizado'
                        )
                    "
                    variant="primary"
                    @click="$emit('edit', item)"
                >
                    <i class="fa fa-pencil"></i>
                </b-btn>
                <b-btn
                    size="sm"
                    variant="danger"
                    @click="$emit('delete', item)"
                >
                    <i class="fa fa-trash"></i>
                </b-btn>
            </template>
        </app-data-table>
        <b-alert show v-else>Esperando datos...</b-alert>
    </div>
</template>
<script>
export default {
    props: {
        data: {
            type: Array,
            required: true,
        },
        onChangePage: {
            type: Function,
        },
    },
    data() {
        return {
            fields,
        }
    },
    methods: {},
    mounted() {},
}
const fields = [
    {
        key: 'client_name',
        label: 'Cliente',
    },
    {
        key: 'city_name',
        label: 'Ciudad',
    },
    {
        key: 'round_date',
        label: 'Fecha',
    },
    {
        key: 'executive_name',
        label: 'Ejecutivo',
    },
    {
        key: 'round_name',
        label: 'Ronda',
    },
    {
        key: 'expected_rounds',
        label: 'Rondas Esperadas',
    },
    {
        key: 'rounds_count',
        label: 'Rondas Realizadas',
    },
    {
        key: 'acomplishment',
        label: 'Cumplimiento',
    },
    {
        key: 'round_users',
        label: 'Ronderos',
    },
]
</script>
